import { Transaction } from '@mysten/sui/transactions';
import {
  sendSuiTx
} from '../../../config/sui';
import { initOptions } from '../../types/types';
import BasicProvider from '../BasicProvider';
import PrioviderUtils from '../ProviderUtils';

// txBytes与txSerialize为transactionBlock的序列化
// 和transactionBlock传入一种即可无需同时传入
interface SuiSignTransactionBlockInput {
  transactionBlock: Transaction;
  chain: string;
  txBytes?: Uint8Array;
  txSerialize?: Uint8Array;
  options?: {
    showEffects: boolean;
  };
}

export default class SuiProvider extends BasicProvider {
  isConnected: boolean = false;
  utils: PrioviderUtils;
  account: {
    address: string;
  };
  chainId: number;

  constructor(options: initOptions) {
    super(options);
    this.chainId = 784;
    this.isConnected = false;
    this._initialize();
  }

  private _initialize() {
    const account = this.utils.storage.get(`accounts`)?.sui;
    if (account) {
      this.account = account;
      this.isConnected = true;
    }
  }

  // change name to connect? like okx? 
  async connectWallet(params?: { email: string }) {
    const res = await super.connect('sui_connectWallet', params);
    this.isConnected = true;
    this.account = res as any;
    console.log('sui connect res', res);
    return res;
  }

  // change name to disconnect? like okx?
  async disconnectWallet() {
    await this.disconnect();
    this.isConnected = false;
    return true;
  }

  getAccount() {
    return this.account;
  }

  // remove?
  getAddress() {
    return this.account?.address || '';
  }

  async sendTransaction(p: { bytes: Uint8Array, signature: string }) {
    const res = await sendSuiTx(p);
    return res;
  }

  // message type align with okx?
  async signMessage(message: string) {
    const res = await this.utils.request({
      method: 'sui_signMessage',
      params: [message],
    });
    return res.result;
  }

  // message type align with okx?
  async signPersonalMessage(message: string) {
    return this.signMessage(message);
  }

  async signTransaction(params: SuiSignTransactionBlockInput) {
    const res = await this.utils.request({
      method: 'sui_signTransaction',
      params: [
        { ...params, chainId: this.chainId },
      ],
    });
    return res.result;
  }

  async signAndExecuteTransaction(params: SuiSignTransactionBlockInput) {
    const tx = await this.signTransaction(params);
    return this.sendTransaction({ bytes: params.txBytes, signature: tx });
  }

  async disconnect() {
    this.account = null;
    super.disconnect('sui_disconnect');
  }
}
